// @flow
import React, {Component}           from 'react';
import Header                       from "../Header/Header";
import {connect}                    from "react-redux";
import {addToCart, toggleSpinner}   from "../../redux/actions";
import Inventory                    from "../../components/Inventory";
import {goToMainPage, goToShopPage} from "../Types/Dispatcher";

class Shop extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            booking: {
                bookingId: '',
                lastName:  ''
            }
        };
    }

    render()
    {
        if (this.props.inventory.list.length === 0) {
            goToMainPage('Shop');
        }
        return (<div className={"page page-shop"}>
            <div className="page-inner-wrapper">
                <Header
                    backButtonVisible={true}
                    onBackButtonClicked={(router) => {
                        const optionalParams = router.route.match.params;
                        const activeFilter   = optionalParams.filter ?? (this.props.shop.filter[0] ?? '');
                        const activeGroup    = optionalParams.group ?? '';

                        if (activeGroup === '') {
                            goToMainPage('Main')
                        } else {
                            goToShopPage('Shop', activeFilter);
                        }
                    }}
                />

                <div className="content-wrapper">
                    <div className="container">
                        <Inventory />
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(state => {
    return {
        pathname:  state.router.location.pathname,
        apiClient: state.app.apiClient,
        cart:      state.app.cart,
        inventory: state.app.inventory,
        shop:      state.app.shop
    }
}, {
                           toggleSpinner,
                           addToCart
                       })(Shop);

